import axios from "axios";

const MuscleApi =  axios.create({
    baseURL: "https://admin.workoutlibrary.org/api/",

    // https://admin.workoutlibrary.org/api/newsletter
})

export default MuscleApi;